import accountsAPI from "@/api/accounts";
import moment from 'moment';

const getDefaultState = () => ({
  mandateHistory: [],
  isMandateHistoryLoading: false,
  isMandateHistoryError: false,

  isMandateHistoryErrorResponse: null,
  isDownloadMandateLoading: {},
  isDownloadMandateError: false,
  isDownloadMandateErrorResponse: null,

  paginationConfigs: {
    paginationCount: 0,
    itemsPerPage: 25,
    page: 1,
  },
});

const state = getDefaultState();

const mutations = {
  FETCH_MANDATE_HISTORY_BEGIN(state) {
    state.isMandateHistoryLoading = true;
    state.isMandateHistoryError = false;
    state.isMandateHistoryErrorResponse = null;
  },
  FETCH_MANDATE_HISTORY_SUCCESS(state, payload) {
    state.mandateHistory = payload.data;
    state.paginationConfigs.paginationCount = parseInt(payload.headers['pagination-count']);
    state.paginationConfigs.itemsPerPage = parseInt(payload.headers['pagination-limit']);
    state.paginationConfigs.page = parseInt(payload.headers['pagination-page']);
    state.isMandateHistoryLoading = false;
  },
  FETCH_MANDATE_HISTORY_ERROR(state) {
    state.isMandateHistoryLoading = false;
    state.isMandateHistoryError = true;
    state.isMandateHistoryErrorResponse = null;
  },

  DOWNLOAD_MANDATE_BEGIN(state, id) {
    this._vm.$set(state.isDownloadMandateLoading, id, true);
    state.isDownloadMandateError = false;
    state.isDownloadMandateErrorResponse = null;
  },
  DOWNLOAD_MANDATE_SUCCESS(state, id) {
    this._vm.$delete(state.isDownloadMandateLoading, id);
  },
  DOWNLOAD_MANDATE_ERROR(state, { id, err }) {
    this._vm.$delete(state.isDownloadMandateLoading, id);
    state.isDownloadMandateError = true;
    state.isDownloadMandateErrorResponse = err;
  },
  
  RESET_MANDATE_HISTORY(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchMandateHistory({ commit, dispatch }, { account, options }) {
    commit("FETCH_MANDATE_HISTORY_BEGIN");
    try {
      let res = await accountsAPI.getDdMandateHistory({ account, options: options });
      commit("FETCH_MANDATE_HISTORY_SUCCESS", res);
    } catch(error) {
      commit("FETCH_MANDATE_HISTORY_ERROR", error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },

  async downloadMandate({ commit, dispatch }, { id, account }) {
    commit("DOWNLOAD_MANDATE_BEGIN", id);
    try {
      const mandate = await accountsAPI.getDDMandatePDF(id);

      const url = window.URL.createObjectURL(mandate.data)
      const link = document.createElement('a');
      link.href = url;
      link.download = `Direct Debit Mandate - ${account} - ${id}`;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);

      commit("DOWNLOAD_MANDATE_SUCCESS", id);
    } catch(err) {
      commit("DOWNLOAD_MANDATE_ERROR", { id, err: err.response.data.message });
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getMandateHistory: state => state.mandateHistory,
  getIsMandateHistoryLoading: state => state.isMandateHistoryLoading,
  getIsMandateHistoryError: state => state.isMandateHistoryError,
  getIsMandateHistoryErrorResponse: state => state.isMandateHistoryErrorResponse,
  getPaginationConfigs: state => state.paginationConfigs,

  getIsDownloadMandateLoading: state => (id) => !!state.isDownloadMandateLoading[id],
  getIsDownloadMandateError: state => state.isDownloadCMandateError,
  getIsDownloadMandateErrorResponse: state => state.isDownloadMandateErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
